interface SetParamsOptions {
  title?: string;
  nodeUrl?: string;
  externalLink?: string;
  targetBlank: boolean;
}

interface LinkParams {
  isLink: true;
  as: 'link';
  to: string;
  target: '_blank' | '_self';
  label: string;
  exact: true;
}

interface AnchorParams {
  isLink?: false;
  as: 'a';
  href?: string;
  target: '_blank' | '_self';
  label: string;
}

type SetParamsResult = LinkParams | AnchorParams;

export const setParams = ({
  title,
  nodeUrl,
  externalLink,
  targetBlank,
}: SetParamsOptions): SetParamsResult => {
  const target = targetBlank ? '_blank' : '_self';
  const label = title ?? '';

  if (nodeUrl) {
    return {
      isLink: true,
      as: 'link',
      to: nodeUrl,
      target,
      label,
      exact: true,
    };
  }

  return {
    as: 'a',
    href: externalLink,
    target,
    label,
  };
};
